const ON_CHANGE_DEBOUNCE_TIMER = 300;
const NEXT_DAY_DISPATCH_CUTOFF_UTC_HOUR = 15;

window.NEXT_DAY_DISPATCH_CUTOFF_UTC_HOUR = NEXT_DAY_DISPATCH_CUTOFF_UTC_HOUR;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
